var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F2F2F",
  fillRule: "evenodd",
  d: "M15.768.207c.3.286.31.76.025 1.06L5.884 11.66a.75.75 0 0 1-1.073.013L.22 7.08a.75.75 0 1 1 1.06-1.06l4.049 4.048L14.707.232a.75.75 0 0 1 1.06-.025",
  clipRule: "evenodd"
})));
export default SvgTick;